import { MouseEventHandler, ReactNode } from 'react';
import { IconElement } from '../common';
import { ButtonWithAsProp } from '../Button';

export interface FloatingNotificationProps {
  dataHook?: string;
  className?: string;
  type?: FloatingNotificationType;
  showCloseButton?: boolean;
  onClose?: MouseEventHandler<HTMLButtonElement>;
  textButtonProps?: FloatingNotificationButtonProps;
  buttonProps?: FloatingNotificationButtonProps;
  prefixIcon?: IconElement;
  text?: ReactNode;
  width?: string;
  fullWidth?: boolean;
}

export type FloatingNotificationType =
  | 'standard'
  | 'success'
  | 'destructive'
  | 'warning'
  | 'premium'
  | 'preview'
  | 'dark';

export type FloatingNotificationButtonProps = ButtonWithAsProp<{
  label?: ReactNode;
}>;
